module.exports = __webpack_public_path__ + "static/media/dialogue-next.416eea5a.mp3";